import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as actions from '../../../store/actions';
import { withRouter } from 'react-router';
import Wrp from "../../../hoc/Wrp/Wrp";
import { getWindowObjectUsingWindowName } from '../../../Utils/UserFunctions';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import { callPOST, callGET, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import {findFieldWithFilterByName,getSelectedValueBasedOnField,deleteViolationsMsg, stringHasText} from '../../../Utils/CommonFunctions';
import TableRecord from "../../../Components/UI/TableRecord";
import Icons from '../../../Components/Icons/Icons';
import CreateNew from './CreateNew';

class TaxDetailsContainer extends Component {
	state = {
		createTaxModel : false,
		taxList : [],
		countryList : [],
		violations : null,
		tax_formfields : {
			id : null,
			name : '',
			valid_from_date : '',
			from_country : '',
			from_province : '',
			to_country : '',
			to_province : '',
			tax_exempt : false,
			rate : '',
			is_active : false
		},
		tableRecords:{
	      tableHead:[
	      	{
              name:"Action",
              type:"Actions",
              href:"",
              isShow:true,
              clickHandler:"",
              attributes:{
                style:{width: "75px"}
              }
            },
	        {
	          name:"Name",
	          type:"Setting",
	          clickHandler:"",
	          isShow:true,
	          attributes:{ }
	        },
	        {
	          name:"From Country",
	          type:"Text",
	          isShow:true,
	        },
	        {
	          name:"From Region",
	          type:"Text",
	          isShow:true,
	        },
	        {
	          name:"To Country",
	          type:"Text",
	          isShow:true,
	        },
	        {
	          name:"To Region",
	          type:"Text",
	          isShow:true,
	        },
	        {
	          name:"Valid from date",
	          type:"Text",
	          isShow:true,
	        },
	        {
	          name:"Rate",
	          type:"Text",
	          isShow:true,
	        }
	      ],
	      tableData:[], 
	      pagination:{
	        page:0,
	        orderBy:'name',
	        perPage:10,
	        direction:'DESC',
	        totalRecords:0,
	        search:''
	      }
	    }
	}

	componentWillMount() {
		this.taxList(this.state.tableRecords.pagination);
	}

	taxList = (pagination) => {
		this.props.Loader();
	    const page = pagination.page; 
	    const orderBy = pagination.orderBy; 
	    const perPage = pagination.perPage; 
	    const direction = pagination.direction; 
	    const search = pagination.search;
	    this.setState({
	      tableRecords:{
	        ...this.state.tableRecords,
	        pagination:pagination
	      }
	    });
	    const url = "tax/list";
	    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
	    callGET(url+queryString)
	    .then(response => {
	      // console.log(response);
	      this.props.Loader();
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
	        if(responseData.data!==null){
	          // load county list
	          const countryList = [];
	          if(responseData.data.country_list) {
            	Object.keys(responseData.data.country_list).forEach(function(key) {
            		const value = {
                      "value": key,
                      "label": responseData.data.country_list[key],
                    }
				    countryList.push(value);
				});
              }
			  let updateTableData = responseData.data.tax_list.content.map((item,index)=>{
	              return {
	                className:' ',
	                rowId:item.id,
	                data:{
	                	actions:[
	                			{
				                  clickHandler:this.editHandler.bind(this,item),
				                  attributes:{
				                    className:"p-1"
			                  	  },
				                  //iconClass:"fas fa-pencil-alt third_dark_color",
				                  svgIcon:'Edit',
				                  name:""
			                  },
			                  {
			                    attributes:{
			                      className:"p-1"
			                    },
			                    // iconClass:"fas fa-trash-alt primary_color",
			                    clickHandler:this.deleteHandler.bind(this,item.id),
			                    svgIcon:"Delete",
			                    name:""
			                  } 
			                  
			              ],
		                name: {
		                    value: item.name,
		                    clickHandler:this.editHandler.bind(this,item),
		                    param:{
		                      data:{...item},
		                    },
		                    attributes:{
		                      id: item.id
		                      // is_editable: item.is_editable.toString(),
		                    },
		                    setting:{}
	                  	},	
		                from_country:item.from_country,
		                from_province:item.from_province,
		                to_country:item.to_country,
		                to_province:item.to_province,
						valid_from_date:item?.valid_from_date?item.valid_from_date.toString().split('T')[0]:'-',
						rate:item.rate
	              }
	            }
	          });
	          const totalRecords = responseData.data.tax_list.total_elements;
	          
	          this.setState({status:200,countryList:countryList,tableRecords:{
	              tableData:{data:updateTableData,status:200},
	              tableHead:this.state.tableRecords.tableHead ,
	              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
	          }});
	          // console.log(this.state.tableRecords);
	      }else{
	          const totalRecords = 0;//response.data.totalElements;
	          this.setState({status:200,tableRecords:{
	              tableData:[],
	              tableHead:this.state.tableRecords.tableHead ,
	              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
	          }});    
	      }
	    }else{
	        // this.props.Loader();
	        this.props.failMessage(responseData.message);   
	        const totalRecords = 0;//response.data.totalElements;
	          this.setState({status:200,tableRecords:{
	              tableData:[],
	              tableHead:this.state.tableRecords.tableHead ,
	              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
	          }});    
	    }
	    })
	    .catch(err => {
	      this.props.Loader();
	        console.log("Connction Error============",err);
	    });
  	}

	createTaxToggle = () => {
		const updateState = {...this.state}
		if(updateState.createTaxModel === true) {
			this.clearForms();
		}else {
			updateState.createTaxModel = !updateState.createTaxModel;
			this.setState(updateState);
		}
	}

	createTaxChangeHandler = (e) => {
		const {name,value} = e.target;
		const updateState = {...this.state}
		if(name === 'tax_exempt') {
			updateState['tax_formfields']['tax_exempt'] = e.target.checked;	
		}else {
			updateState['tax_formfields'][name] = value;	
		}
		if(this.state.violations) {
      let viol = this.state.violations;
      if(name === 'name') {
        viol = deleteViolationsMsg('name',this.state.violations);
      }
      updateState['violations'] = viol;
    }
		this.setState(updateState);
	}

	createTaxFilterOnChange = (e) => {
		// console.log(e);
		let datevalue = '';
		let dateSysvalue = '';
		let value = [];
		if (typeof e.format === "function") {
			datevalue = e.format('yyyy-MM-DD HH:mm:ss'); 
		}
		// console.log(datevalue);
		const updateState = {...this.state}
		updateState['tax_formfields']['valid_from_date'] = datevalue;
		this.setState(updateState);
	}

	saveTaxDetails = () => {
		this.props.Loader();
		const taxFields = this.state.tax_formfields;
		let body = {};
		if(taxFields.id) {
			body = {
				id: taxFields.id,
				name: taxFields.name,
				valid_from_date: taxFields.valid_from_date,
				// valid_from_date:null,
				from_country: taxFields.from_country,
				from_province: taxFields.from_province,
				to_country: taxFields.to_country,
				to_province: taxFields.to_province,
				tax_exempt: taxFields.tax_exempt,
				rate: parseFloat(taxFields.rate)
			}
		}else {
			body = {
				name: taxFields.name,
				valid_from_date: taxFields.valid_from_date,
				// valid_from_date:null,
				from_country: taxFields.from_country,
				from_province: taxFields.from_province,
				to_country: taxFields.to_country,
				to_province: taxFields.to_province,
				tax_exempt: taxFields.tax_exempt,
				rate: parseFloat(taxFields.rate)
			}
		}
		console.log(JSON.stringify(body));

		callPOST("tax/save",body)
	      .then(response => {
	        this.props.Loader();
	        // console.log(response);
	        const responseData = response.data;
	        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	          this.props.succMessage(responseData.message);
	          this.createTaxToggle();
	          this.taxList(this.state.tableRecords.pagination);
	        }else {
	        	let viol = {};
	          let errMsg = '';
	          if(responseData.violations) {
	            // const rules = [...conditionList];
	            responseData.violations.map((arr,ind) => {
	              const data = arr.field_name+':'+arr.message;
	              viol[arr['field_name']]= arr['message'];
	              errMsg += ind === 0 ? data : '<br />'+data;
	            })
	            this.setState({violations:viol});
	          }
	          this.props.failMessage(responseData.message+"<br/>"+errMsg);
	        }
	      })
	      .catch(err => {
	        this.props.Loader();
	        this.props.failMessage("Error occured");
	        console.log(err);
	      })
	}

	deleteHandler = (ide) => {
		console.log("ide",ide);
		this.props.Loader();
		// let isDelete = window.confirm("are you sure you want to delete this data?");
		// if(isDelete) {
			callDELETE("tax/"+ide)
			.then(response => {
				this.props.Loader();
		        console.log(response);
		        const responseData = response.data;
		        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
		          this.props.succMessage(responseData.message);
		          this.taxList(this.state.tableRecords.pagination);
		        }else {
		          this.props.failMessage(responseData.message);
		        }
			})
			.catch(err => {
		        this.props.Loader();
		        this.props.failMessage("Error occured");
		        console.log(err);
	      	})
		// }
	}

	editHandler = (data) => {
		// console.log(id);
		const updateState = {...this.state}
		updateState['tax_formfields']['id'] = data.id;
		updateState['tax_formfields']['name'] = data.name;
		updateState['tax_formfields']['valid_from_date'] = data.valid_from_date;
		updateState['tax_formfields']['from_country'] = data.from_country;
		updateState['tax_formfields']['from_province'] = data.from_province;
		updateState['tax_formfields']['to_country'] = data.to_country;
		updateState['tax_formfields']['to_province'] = data.to_province;
		updateState['tax_formfields']['tax_exempt'] = data.tax_exempt;
		updateState['tax_formfields']['rate'] = data.rate;
		updateState['createTaxModel'] = true;
		this.setState(updateState);
	}

	clearForms = () => {
		const updateState = {...this.state}
		updateState['tax_formfields']['id'] = null;
		updateState['tax_formfields']['name'] = '';
		updateState['tax_formfields']['valid_from_date'] = '';
		updateState['tax_formfields']['from_country'] = '';
		updateState['tax_formfields']['from_province'] = '';
		updateState['tax_formfields']['to_country'] = '';
		updateState['tax_formfields']['to_province'] = '';
		updateState['tax_formfields']['tax_exempt'] = '';
		updateState['tax_formfields']['rate'] = '';
		updateState['createTaxModel'] = false;
		this.setState(updateState);
	}

	select2OnChangeHandler = (value, name) => {
		// console.log(name,value);
		const updateState = { ...this.state };
		updateState['tax_formfields'][name] = value;
		if(this.state.violations) {
      let viol = this.state.violations;
      if(name === 'from_country') {
        viol = deleteViolationsMsg('fromCountry',this.state.violations);
      }else if(name === 'to_country') {
        viol = deleteViolationsMsg('toCountry',this.state.violations);
      }
      updateState['violations'] = viol;
    }
		this.setState(updateState);
	}

	render () {
      const breadCrumbs =  {
          backHistory : [{
          href : "/settings",
          name:"Settings"
          }],
          pageTitle:"Tax",
          buttonList:[{
            href:"",
            clickHandler:this.createTaxToggle,
            name: "Add New",
            svgIcon:"AddPlus",
            attributes:{
              className:"btn primary_bg mr-2"
            },
            type:"addnew",
            icon:"",
          }]
      }

      // console.log(this.state.tableRecords.pagination.totalRecords);

    return(
      <Wrp>
      	<BreadCrumbs breadCrumbsList={breadCrumbs} />
        <div className="viewport">
          <div className="view view-xl">
            <div className="outerPort">
            	 
            	<TableRecord 
                  tableRecords={this.state.tableRecords} 
                  recordsChangeHandler={this.taxList}
                />
            	<CreateNew
            		modelOpen = {this.state.createTaxModel}
            		toggleModel={this.createTaxToggle}
            		curState = {this.state}
            		createTaxChangeHandler={this.createTaxChangeHandler}
            		filterOnChange={this.createTaxFilterOnChange}
            		saveTaxDetails={this.saveTaxDetails}
            		select2OnChangeHandler={this.select2OnChangeHandler}
            	/>
            	 
            </div>
          </div>
        </div>
      </Wrp>
    )
	}
}

const mapStateToProps = state => {
  return {
    authenticated: state,
    selectedWindowData:state.reducer.selectedWindowData,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : () => dispatch(actions.loader()),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TaxDetailsContainer));